import React, {useEffect, useState} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Wallet from '../common/wallet/wallet';
import {useDispatch, useSelector} from 'react-redux';
import { formatNumberCurrency } from '../../utils/formatNumberCurrency';
import { CAMPAIGN_STATUS } from '../../constants';
import AirdropCountdown from '../common/AirdropCountdown';
import { getNetworkObject } from '../../utils/campaignUltils';
import allActions from '../../actions';
import { useIdoTokenClaimContract as IdoTokenClaimContract } from '../../hooks/useContract';
import {_isClaimedSC } from './utils';
import WagmiConnect from '../common/wagmi-connect';
import { useAccount } from 'wagmi';
import { useWeb3ModalState } from '@web3modal/wagmi/react';

const ItemAirdrop = ({item}) => { 
    const { address } = useAccount();
    const { selectedNetworkId } = useWeb3ModalState()
    const chainId = selectedNetworkId;
    let account = address;

    const dispatch = useDispatch();
    const [isWhitelist, setIsWhitelist] = useState();
    const [isClaim, setIsClaim] = useState(false); 
    const [expiredDateValue, setExpiredDateValue] = useState(""); 
    const airdropContract = IdoTokenClaimContract(isWhitelist && isWhitelist?.data?.contractAddress);
    const nowDate = new Date();
    
    useEffect(() => {
        if(item?.id && account) {
            dispatch(allActions.airdropAction.getWhitelistAirdropByAddress(item?.id, account.toLowerCase(),(res)=>{ 
                setIsWhitelist(res);   
                var startClaimDate = new Date(item?.startClaim);
                var expiredDate = startClaimDate;
                expiredDate.setDate(startClaimDate.getDate() + 7);
                setExpiredDateValue(expiredDate); 
            })); 
        }
    }, [account]);  

    useEffect(() => {
        try {
            if (airdropContract !== null) {
                _isClaimedSC(airdropContract, account).then((res) => { 
                    setIsClaim(res);
                });
            }
        } catch (error) {
            setIsClaim(false);
        }
    }, [account, airdropContract]); 
    
    const handleBtnRound = () => {
        let elmBtnRound = '';
        if(item.status === CAMPAIGN_STATUS.UPCOMING) {
            elmBtnRound = ( <p className='btn-upcoming-airdrop'>
                            <AirdropCountdown item={item} positions="AIRDROP" />
                            </p>);
        } else if(item.status === CAMPAIGN_STATUS.OPENING) {
            elmBtnRound = <a className="c-btn" href={item.joinNowUrl}>Join Now</a>;
        } else if(item.status === CAMPAIGN_STATUS.COMPLETED){ 
            if(isWhitelist){  
                if(isClaim){
                    elmBtnRound = <Link className="c-btn disable" disabled>Claimed</Link>;  
                }
                else{
                    if(nowDate > expiredDateValue) {
                        elmBtnRound = <Link className="c-btn disable" disabled>Expired</Link>;    
                    } 
                    else{
                        elmBtnRound = <Link className="c-btn" to={`/airdrop-detail/${item.handle}`}>Claim</Link>;
                    } 
                } 
            }
            else{
                elmBtnRound = <Link className="c-btn disable" disabled>Not Whitelist</Link>;
            } 
        }
        return elmBtnRound;
    };

    const networkChain = getNetworkObject(item.network);

    const formatAMPM = (date) => {
        var hours = date.getUTCHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const startJoinPoolDate = new Date(item.startJoinPool);
    const endJoinPoolDate = new Date(item.endJoinPool);
 
    const newDateStart = formatAMPM(startJoinPoolDate)+' ' + months[startJoinPoolDate.getMonth()] + ' ' + startJoinPoolDate.getUTCDate();
    const newDateEnd = formatAMPM(endJoinPoolDate) + ' ' + months[endJoinPoolDate.getMonth()] + ' ' + endJoinPoolDate.getUTCDate(); 
     
    return(
        <div className="c-list__item">
            <div className="c-list__img">
                <img src={item?.bannerURL} alt="Special Giveaway" />
                <div className={`c-list__status ${item.status}`}>{item.status}</div>
            </div>
            <div className="c-list__mainhead">
                <h3 className="c-list__head">{item.title}</h3>
                <p className="c-list__detail">
                    <a href={item.detailUrl} target="_blank">Detail &#62;</a>
                </p>
            </div> 
            <div className="c-list__body"> 
                <p className="c-list__row">
                    <span>Reward:</span>
                    <span>${formatNumberCurrency(item.totalRaise)} worth of {item?.tokenInform?.symbol}</span>
                </p>
                <p className="c-list__row">
                    <span className='duration'>Duration: (UTC)</span>
                    <span>{newDateStart} <br />{newDateEnd}</span>
                </p>
                <p className="c-list__row">
                    <span>Network:</span>
                    <span><img src={networkChain.logo} alt={networkChain.name} />{networkChain.name}</span>
                </p>
               
            </div>
            <div className="c-list__footer airdrop-btn">
                {!account ? <WagmiConnect /> : handleBtnRound()}           
            </div>
        </div>
    )
}

export default ItemAirdrop;